
import { SVGProps } from "react";

export const ArrowUpIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={props.width || "10"} height={props.height || "5"} viewBox="0 0 10 5" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9 4L5.6 1.45C5.24444 1.18333 4.75556 1.18333 4.4 1.45L1 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
);
